function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { useDropdownContext } from './context';
import { Icon } from '../../atoms/Icon/index';
import { TextField } from '../TextField/TextField';
export var DropdownToggle = function DropdownToggle(props) {
  var _useDropdownContext = useDropdownContext(),
      toggle = _useDropdownContext.toggle,
      open = _useDropdownContext.open,
      dropdownRef = _useDropdownContext.dropdownRef;

  var toggleRef = useRef(null);

  var blurToggleButton = function blurToggleButton() {
    if (dropdownRef.current) {
      var toggleItem = toggleRef.current ? toggleRef.current : dropdownRef.current.querySelector('.telia-dropdown-toggle > button');

      if (toggleItem) {
        toggleItem.blur();
      }
    }
  };

  useEffect(function () {
    blurToggleButton();
  }, [open]);
  var Tag = props.tag || 'span';

  if (props.children) {
    return /*#__PURE__*/React.createElement(Tag, {
      className: "telia-dropdown-toggle"
    }, React.Children.map(props.children, function (child) {
      return typeof child === 'string' ? /*#__PURE__*/React.createElement("div", {
        onClick: toggle
      }, child) : /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, _objectSpread({
        onClick: toggle,
        ref: toggleRef
      }, props)) : null;
    }));
  }

  return /*#__PURE__*/React.createElement("button", {
    ref: toggleRef,
    onClick: toggle,
    type: props.type,
    className: cn('telia-dropdown-toggle telia-dropdown-toggle__default', {
      'telia-dropdown-toggle__hideLabel': props.hideLabel,
      'telia-dropdown-toggle__purple': props.color === 'purple',
      'telia-dropdown-toggle__white': props.color === 'white',
      'telia-dropdown-toggle__outline': props.outline !== false,
      'telia-dropdown-toggle__disabled': props.disabled
    }, props.className),
    disabled: props.disabled
  }, props.icon ? /*#__PURE__*/React.createElement(Icon, {
    className: "telia-dropdown-toggle-icon",
    icon: props.icon
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "telia-dropdown-toggle-label"
  }, props.label), /*#__PURE__*/React.createElement(Icon, {
    className: "telia-dropdown-toggle-caret",
    icon: "arrow-small-down"
  }));
};
export var DropdownSearchToggle = function DropdownSearchToggle(props) {
  var _useDropdownContext2 = useDropdownContext(),
      setMenuOpen = _useDropdownContext2.setMenuOpen,
      setHighlightIndex = _useDropdownContext2.setHighlightIndex;

  var leftContent = props.icon ? /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    style: {
      height: '1.5rem',
      width: '1.5rem'
    }
  }) : props.leftContent;
  return /*#__PURE__*/React.createElement(TextField, _extends({
    className: "telia-dropdown-toggle telia-dropdown-toggle__search",
    value: props.value,
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      props.onInputChange(e.target.value);
      setHighlightIndex(0);
    },
    onFocus: function onFocus() {
      if (props.openImmediately) {
        setMenuOpen(true);
      }
    },
    leftContent: leftContent,
    autoComplete: "new-off"
  }, props));
};